/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.ShareTabs = class ShareTabs {
  static get($el) {
    return $el.data("ShareTabs");
  }

  constructor(el) {
    this.el = el;
    if (!!!navigator.share) {
      this.el.removeClass("native-sharing-available");
    }

    this.el.removeClass('loading');

    this._skipHiddenTabsOnNavigation();

    if (!Buyapowa.BrowserStorage.get("mobileSharingNotificationReceived")) {
      this._showMobileNotification();
    }
  }

  static hideMobileNotification() {
    const tab = $("[data-tab='mobileSharing']");
    tab.removeClass('notification');
    return Buyapowa.BrowserStorage.set("mobileSharingNotificationReceived", "true");
  }

  _showMobileNotification() {
    return setTimeout(() => {
      return $("[data-tab='mobileSharing']").addClass('notification');
    }
    , 2000);
  }

  _skipHiddenTabsOnNavigation() {
    return this.el.on('keydown', function(event) {
      if ((event.which === 39) || (event.which === 37)) {
        let nextTab;
        const tab = $(event.target).closest("li");

        if (event.which === 39) {
          nextTab = tab.next("li");

          if (nextTab.is(":hidden")) {
            return nextTab.next("li").find("a").focus();
          }

        } else {
          nextTab = tab.prev("li");

          if (nextTab.is(":hidden")) {
            return nextTab.prev("li").find("a").focus();
          }
        }
      }
    });
  }
};
